import React, { Fragment, useMemo, useRef } from "react";
import PropTypes from "prop-types";
import { makeStyles, Typography } from "@material-ui/core";
const isMobile = window.innerWidth <= 768
const DealItemInfo = ({ offer1, offer2, item }) => {
  const {
    wrapperStyle,
    offer1Style,
    offer2Style,
    offer1TextStyle,
    offer1TextSmallStyle,
    offer2TextStyle,
    offer2TextStrikeStyle,
  } = useStyles();

  const isOriginalText = useRef(false);

  const discountAmount = useMemo(() => {
    const { offer_message1, selling_price, item_price } = item;
    if (offer_message1.toLowerCase().includes("buy")) {
      isOriginalText.current = true;
      return offer_message1;
    } else if (offer_message1.toLowerCase().includes("%")) {
      isOriginalText.current = true;
      return offer_message1;
    } else if (offer_message1.toLowerCase().includes("off")) {
      isOriginalText.current = false;
      return `₹${Math.round(selling_price - item_price)}`;
    }
  }, [item]);

  const offer2Texts = useMemo(() => {
    const { offer_message1, offer_message2, selling_price, item_price } = item;
    if (offer_message1.toLowerCase().includes("buy")) {
      return [offer_message2];
    }
    return [`₹${Math.round(parseFloat(selling_price))}`, `₹${Math.round(parseFloat(item_price))}`];
  }, [item]);

  return (
    <div className={wrapperStyle}>
      <div className={offer1Style}>
        <Typography
          className={offer1TextStyle + " " + (isOriginalText.current ? offer1TextSmallStyle : "")}
          variant="caption"
          align="center"
        >
          {discountAmount}
          {!isOriginalText.current && (
            <>
              <br />
              <span>OFF</span>
            </>
          )}
        </Typography>
      </div>
      <div className={offer2Style}>
        <Typography className={offer2TextStyle}>
          {offer2Texts.map((text, index) => {
            const strike = offer2Texts.length > 1 && index === 0;
            return (
              <Fragment key={text}>
                <span className={strike ? offer2TextStrikeStyle : ""}>{text}</span>
              </Fragment>
            );
          })}
        </Typography>
      </div>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  wrapperStyle: {
    width: "100%",
    backgroundColor: theme.palette.primary.main,
    position: "relative",
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
  },
  offer1Style: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    padding: theme.spacing(0.5),
    width: isMobile ? 81 : 90,
    height: isMobile ? 76 : 86,
    borderRadius: 1000,
    position: "absolute",
    left: -20,
    bottom: -20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  offer1TextStyle: {
    fontWeight: "bold",
    lineHeight: 0.75,
    fontSize: isMobile ? 16 : 20,
    whiteSpace: "break-spaces",
    marginLeft: 20,
    marginBottom: 10,
    marginRight: theme.spacing(0.5),

    "& > span": {
      fontSize: 13,
    },
  },
  offer1TextSmallStyle: {
    fontSize: 15,
    lineHeight: 1,
  },
  offer2Style: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    marginLeft: theme.spacing(1.5) + 70,
    marginRight: theme.spacing(isMobile ? 1 : 2),
    marginTop: theme.spacing(0.5),
  },
  offer2TextStyle: {
    color: theme.palette.secondary.contrastText,
    fontSize: isMobile ? 16 : 20,
    fontWeight: "bold",
  },
  offer2TextStrikeStyle: {
    textDecoration: "line-through",
    marginRight: 8,
    fontSize: 12,
    fontWeight: 400,
    verticalAlign: "middle",
  },
}));

DealItemInfo.propTypes = {
  offer1: PropTypes.string,
  offer2: PropTypes.string,
  item: PropTypes.object,
};

export default DealItemInfo;
